module.exports = __webpack_public_path__ + "static/img/1-1Z5291P144Q2.4455f6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5291P144Q2.jpg
// module id = WbuT
// module chunks = 0